import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const RoleBasedDashboard = () => {
  const { user, loading } = useAuth();

  // Log pour déboguer
  console.log("Utilisateur :", user);
  console.log("Rôle de l'utilisateur :", user?.role);

  if (loading) return <div>Chargement...</div>;
  
  if (!user || !user.role) {
    return <div>Rôle utilisateur non défini.</div>;
  }

  // Redirection en fonction du rôle de l'utilisateur
  switch (user.role.toLowerCase()) {
    case "superadmin":
      return <Navigate to="/admin" replace />;
    case "projectmanager":
      return <Navigate to="/admin" replace />;
    case "admin":
      return <Navigate to="/admin" replace />;
    case "client":
  // Si l'utilisateur va vers les paramètres admin client, on laisse passer
  if (window.location.pathname.startsWith('/clients/')) {
    return null; // Ne pas rediriger, laisser React Router gérer
  }
  // Sinon, redirection normale vers le dashboard client
  return <Navigate to="/client" replace />;
    case "charge-affaire":  // Nouveau cas pour le chargé d'affaire
      return <Navigate to="/admin" replace />; // Ou créez une route spécifique plus tard
    default:
      return <div>Rôle inconnu : {user.role}</div>;
  }
};

export default RoleBasedDashboard;